exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.invoice-logo[data-v-7f2c2906] {\n    height: 1in;\n}\n.invoice-paid[data-v-7f2c2906] {\n    font-size: 1.25rem;\n}\n", ""]);

// exports
